export default __webpack_public_path__ + "static/media/Ostali 1.08f50ca6.jpg";